import { HistoryClient, VehicleEventsModel, VehicleModel, VehicleTypesSpeedModel, VehiclesClient } from './../../core/services/api.service';
import { State, Selector, Action, StateContext } from '@ngxs/store';

import { tap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AddVehicleFailAction, AddVehicleSuccessAction, AddVehicleAction, LoadVehiclesAction,
        LoadVehiclesFailAction,
        LoadVehiclesSuccessAction,
        GetVehicleEventsSuccessAction,
        GetVehicleEventsFailAction,
        GetVehicleEventsAction,
        GetVehicleByIdAction,
        GetVehicleByIdSuccessAction,
        GetVehicleByIdFailAction,
        GetVehicleLocFromEventAction,
        GetVehicleLocFromEventSuccessAction,
        GetVehicleLocFromEventFailAction,
        GetVehicleSpeedByTypeAction,
        GetVehicleSpeedByTypeSuccessAction,
        GetVehicleSpeedByTypeFailAction} from './vehicles.action';


export class VehiclesStateModel {
  public isLoading: boolean;
  public vehicles: VehicleModel[];
  public vehicle: VehicleModel;
  public vehicleEvent: VehicleEventsModel;
  public vehicleTypesSpeed: VehicleTypesSpeedModel;
  public vehicleEvents: VehicleEventsModel[];
  public id: number
  public showSpinner: boolean;
}

@State<VehiclesStateModel>({
  name: 'Vehicles',
  defaults: {
    isLoading: true,
    vehicles: [],
    vehicleEvent: undefined,
    vehicleTypesSpeed: undefined,
    vehicleEvents: [],
    vehicle: undefined,
    id: 0,
    showSpinner: false,

  }
})
@Injectable()
export class VehiclesState {
  constructor(private vehiclesService: VehiclesClient, private vehicleHistory: HistoryClient) { }

  @Selector()
  static getIsLoading(state: VehiclesStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getAllVehicles(state: VehiclesStateModel) {
    return state.vehicles;
  }

  @Selector()
  static getVehicleEventsByTourId(state: VehiclesStateModel) {
    return state.vehicleEvents;
  }

  @Selector()
  static getVehicleLocFromEvent(state: VehiclesStateModel) {
    return state.vehicleEvent;
  }

  @Selector()
  static getVehicleById(state: VehiclesStateModel) {
    return state.vehicle;
  }


  @Selector()
  static getVehicleSpeedByTypeAction(state: VehiclesStateModel) {
    return state.vehicleTypesSpeed;
  }


  @Action(LoadVehiclesAction)
  loadVehiclesAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: LoadVehiclesAction) {
    patchState({ showSpinner: true });

    return this.vehiclesService.getAllVehicles(action.payload.searchTerm).pipe(
      tap((vehicles) => dispatch(new LoadVehiclesSuccessAction({ vehicles }))),
      catchError((err) => dispatch(new LoadVehiclesFailAction()))
    );
  }

  @Action(LoadVehiclesSuccessAction)
  loadVehiclesSuccessAction(ctx: StateContext<VehiclesStateModel>, action: LoadVehiclesSuccessAction) {
    ctx.patchState({
      showSpinner: false,
      vehicles: action.payload.vehicles
    });
  }

  @Action(LoadVehiclesFailAction)
  loadVehiclesFailAction(ctx: StateContext<VehiclesStateModel>, action: LoadVehiclesFailAction) {
    ctx.patchState({
      showSpinner: false,
      vehicles: undefined
    });
  }

  //add vehicle
  @Action(AddVehicleAction)
  addVehicleAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: AddVehicleAction) {
    patchState({ isLoading: true });

     return this.vehiclesService.addVehicle(action.regNumber, action.id).pipe(
       tap((vehicle) => {
         return dispatch(new AddVehicleSuccessAction({ vehicle: vehicle }));
       }),
       catchError(error => {
         dispatch(new AddVehicleFailAction());
         throw error;
       })
     )}


    @Action(GetVehicleEventsAction)
        getVehicleEventsAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: GetVehicleEventsAction) {
          patchState({ showSpinner: true });

          return this.vehicleHistory.getVehicleEventsByTourId(action.Id).pipe(
            tap((vehicleEvents) => dispatch(new GetVehicleEventsSuccessAction({ vehicleEvents }))),
            catchError((err) => dispatch(new GetVehicleEventsFailAction()))
          );
        }

        @Action(GetVehicleEventsSuccessAction)
        getVehicleEventsActionSuccessAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleEventsSuccessAction) {
          ctx.patchState({
            showSpinner: false,
            vehicleEvents: action.payload.vehicleEvents
          });
        }

        @Action(GetVehicleEventsFailAction)
        getVehicleEventsActionFailAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleEventsFailAction) {
          ctx.patchState({
            showSpinner: false,
            vehicles: undefined
          });
        }

    //Get vehicle by id
       @Action(GetVehicleByIdAction)
       getVehicleByIdAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: GetVehicleByIdAction) {
          patchState({ showSpinner: true });

          return this.vehiclesService.getVehicleById(action.Id).pipe(
            tap((vehicle) => dispatch(new GetVehicleByIdSuccessAction({ vehicle }))),
            catchError((err) => dispatch(new GetVehicleByIdFailAction()))
          );
        }

        @Action(GetVehicleByIdSuccessAction)
        getVehicleByIdActionSuccessAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleByIdSuccessAction) {
          ctx.patchState({
            showSpinner: false,
            vehicle: action.payload.vehicle
          });
        }

        @Action(GetVehicleByIdFailAction)
        getVehicleByIdActionFailAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleByIdFailAction) {
          ctx.patchState({
            showSpinner: false,
            vehicle: undefined
          });
        }

    //Get vehicle Location
    @Action(GetVehicleLocFromEventAction)
    getVehicleLocFromEventAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: GetVehicleLocFromEventAction) {
       patchState({ showSpinner: true });

       return this.vehicleHistory.getVehicleLocFromEvents(action.Id).pipe(
         tap((vehicleEvent) => dispatch(new GetVehicleLocFromEventSuccessAction({ vehicleEvent }))),
         catchError((err) => dispatch(new GetVehicleLocFromEventFailAction()))
       );
     }

     @Action(GetVehicleLocFromEventSuccessAction)
     getVehicleLocFromEventSuccessAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleLocFromEventSuccessAction) {
       ctx.patchState({
         showSpinner: false,
         vehicleEvent: action.payload.vehicleEvent
       });
     }

     @Action(GetVehicleLocFromEventFailAction)
     getVehicleLocFromEventFailAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleLocFromEventFailAction) {
       ctx.patchState({
         showSpinner: false,
         vehicleEvent: undefined
       });
     }

     //Get vehicle speed
    @Action(GetVehicleSpeedByTypeAction)
    getVehicleSpeedByTypeAction({ dispatch, patchState }: StateContext<VehiclesStateModel>, action: GetVehicleSpeedByTypeAction) {
       patchState({ showSpinner: true });

       return this.vehiclesService.getVehicleSpeedByType(action.VehicleType).pipe(
         tap((vehicleTypesSpeed) => dispatch(new GetVehicleSpeedByTypeSuccessAction({ vehicleTypesSpeed }))),
         catchError((err) => dispatch(new GetVehicleSpeedByTypeFailAction()))
       );
     }

     @Action(GetVehicleSpeedByTypeSuccessAction)
     getVehicleSpeedByTypeSuccessAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleSpeedByTypeSuccessAction) {
       ctx.patchState({
         showSpinner: false,
         vehicleTypesSpeed: action.payload.vehicleTypesSpeed
       });
     }

     @Action(GetVehicleSpeedByTypeFailAction)
     getVehicleSpeedByTypeFailAction(ctx: StateContext<VehiclesStateModel>, action: GetVehicleSpeedByTypeFailAction) {
       ctx.patchState({
         showSpinner: false,
         vehicleTypesSpeed: undefined
       });
     }
}
